module.exports = __webpack_public_path__ + "img/Most-Engaged@2x.8c86ed72.png";